export default class ReactUtils {
  static resolveReference(reactRef) {
    if (reactRef === undefined || reactRef === null)
      return null;

    if (reactRef.current === undefined || reactRef.current === null)
      return null;

    return reactRef.current.instance;
  }
}